import { DistanceUnits, HeadingUnit } from "./types";


const indexedCompassPoints = ["N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE", "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"];

export function constrainAngleDegrees(angle: number) {
    angle = (angle % 360 + 360) % 360;  //Normalise degrees to between 0 & 360
    return angle >= 360 ? 0 : angle;    //Handle zero-crossing
};

export function formatHeading(headingDegrees: number, headingUnit: HeadingUnit): string {
        
    headingDegrees = constrainAngleDegrees(headingDegrees);

    if (headingUnit === HeadingUnit.Cardinal) {
        const val = Math.floor((headingDegrees / 22.5) + 0.5);
        return indexedCompassPoints[(val % 16)];            
    }
    else {  //Assume degress
        return `${headingDegrees.toFixed(0)}°`;
    }

};

export function formatSpeed(speedMetresPerSec: number, units: DistanceUnits): string {
    const convSpeed = convertSpeedToPerHour(speedMetresPerSec, units);
    const unit = units === DistanceUnits.Metric ? 'kmh' : 'mph';
    return `${convSpeed.toFixed(0)} ${unit}`;
};

export function formatAltitude(altitudeMetres: number, units: DistanceUnits): string {
    const convAlt = convertAltitude(altitudeMetres, units);
    const unit = units === DistanceUnits.Metric ? 'm' : 'ft';
    return `${convAlt.toFixed(0)} ${unit}`;
};

export function convertSpeedToPerHour (speedMetresPerSec: number, units: DistanceUnits): number {

    switch (units)
    {
        case DistanceUnits.Imperial:
            return speedMetresPerSec * 2.237;

        case DistanceUnits.Metric:
        default:
            return speedMetresPerSec * 3.6;
    }

};

export function convertAltitude(altitudeMetres: number, units: DistanceUnits): number {

    switch (units)
    {
        case DistanceUnits.Imperial:
            return altitudeMetres * 3.281;

        case DistanceUnits.Metric:
        default:
            return altitudeMetres;
    }

};

export function formatLatLong(latLng: L.LatLng): string {
    return [latLng.lat.toFixed(5), latLng.lng.toFixed(5)].join(', ');
};